import { getApiKey } from './apiKey'
import requests from './requests'
import appData from './appData'
import urls from '../vue/utils/urls'

const api = {}

/**
 * Parse the URL args to get the API url.
 *
 * @since  2.0.0
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {string}      URL
 */
api.url = args => {
	if ('object' !== typeof args) {
		return urls.api(args)
	}
	if (args.endpoint) {
		return urls.api(args.endpoint)
	}
	if (args.wpEndpoint) {
		return urls.wpRest(args.wpEndpoint)
	}
	if (args.url) {
		return args.url
	}

	return ''
}

/**
 * Performs a get request to the OM api.
 *
 * @since  2.0.0
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
api.get = args => api.request('get', args)

/**
 * Performs a post request to the OM api.
 *
 * @since  2.0.0
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
api.post = args => api.request('post', args)

/**
 * Performs a put request to the OM api.
 *
 * @since  2.0.0
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
api.put = args => api.request('put', args)

/**
 * Performs a delete request to the OM api.
 *
 * @since  2.0.0
 *
 * @param  {Object} args Arguments for the request.
 *
 * @returns {Promise}     Returns the request promise.
 */
api.delete = args => api.request('delete', args)

/**
 * Performs a request to the OM api.
 *
 * @since  2.0.0
 *
 * @param  {string} method The request method.
 * @param  {Object} args   Arguments for the request.
 *
 * @returns {Promise}       Returns the request promise.
 */
api.request = (method = 'get', args) => {
	const url = api.url(args)
	if ('object' !== typeof args) {
		args = {}
	}
	args.url = url

	const req = requests.request(method, args).set({
		'X-OptinMonster-ApiKey': getApiKey(),
		'Content-Type': 'application/json',
	})

	if (!args.noNonce && args.wpEndpoint) {
		const nonce = appData.get('nonce')
		if (nonce) {
			req.set({ 'X-WP-Nonce': nonce })
		}
	}

	return req
}

export default api
